import { trackEvent } from '@/utils/track/tools.js'

export default {
  /**
   * 广告创建页曝光
   * @param from_source 来源 1(管理端广告首页) 2(门店端广告首页)
   * @param terminal_type 3(pc) 2(pad) 4(exe)
   */
  showCreatePlan(from_source, terminal_type) {
    trackEvent({
      eventId: 'sailing_b_m_ads_createplan_sw',
      eventLabel: '管理端-广告-创建广告页面的曝光',
      attrs: {
        from_source,
        terminal_type,
      },
    })
  },
  adCreatePlanCK(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_m_ads_createplan_button_ck',
      eventLabel: '广告-创建广告计划页-点击',
      attrs,
    })
  },

  /**
   * 投放广告按钮点击
   */
  clickHomePageCreate(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_m_ads_homepage_create_ck',
      eventLabel: '管理端-广告-投放广告按钮点击',
      attrs,
    })
  },

  /**
   * 广告主页面曝光
   */
  showHomePage(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_m_ads_homepage_sw',
      eventLabel: '管理端广告主页面曝光',
      attrs,
    })
  },

  /**
   * 广告计划列表状态点击
   * @param plan_id 广告计划id
   * @param ck_type 点击类型 1.查看详情 2.暂停 3.重新开启
   */
  clickListAction(plan_id, ck_type) {
    trackEvent({
      eventId: 'sailing_b_m_ads_homepage_plan_action_ck',
      eventLabel: '管理端-广告-广告计划列表-点击',
      attrs: {
        plan_id,
        ck_type,
      },
    })
  },
}
